import * as _ from 'lodash'
export const linkMixin = {
  methods: {
    link: function (config, itemData, value) {
      if (config && config.externalLinkType) {
        switch (config.externalLinkType.toLowerCase()) {
          case 'outlook-assignment':
            if (itemData) {
              return `${
                process.env.VITE_ASSIGNMENT_OVERVIEW_URL
              }${config.link.replace('[viewEventId]', itemData)}`
            }
            case 'outlook-engagement':
              if (itemData) {
                return `${
                  process.env.VITE_ENGAGEMENT_URL
                }${config.link.replace('[engagementId]', itemData)}`
              }
          case 'outlook-box-folder':
            if (itemData) {
              return `${
                process.env.VITE_BOX_FOLDER_URL
              }${config.link.replace('[folderId]', itemData)}`
            }
        }
      }

      return config.link
    },
    linkTarget: function (config) {
      return config && config.linkTarget ? config.linkTarget : '_self'
    },
  },
}